import React, { useEffect, useState } from 'react';
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Upload } from 'antd';
import { ServerAPI } from '../common/ServerAPI';
import { IMAGE_BASE_URL } from '../common/Constants';

const GuarantorDocumentView = ({ documentUrl, documentView, documentViewCLose }) => {
    // console.log(documentUrl);
    return (
        <div>
            {documentUrl != undefined && documentUrl.length > 0 &&
                <Modal open={documentView} footer={null} onCancel={() => { documentViewCLose() }}>
                    <div className={`${documentUrl.length === 1 ? 'bg-opacity-50' : 'bg-opacity-0'}`}>
                        <div className={`modal ${documentUrl.length === 1 ? 'p-4' : ''}`}>
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className={`image-container h-[250px] ${documentUrl.length === 1 ? 'flex justify-center h-[250px]' : 'grid grid-cols-2 gap-4'}`}>
                                        {documentUrl.map((src, index) => (
                                            <div>
                                                <img
                                                    key={index}
                                                    alt={`Image ${index + 1}`}
                                                    src={IMAGE_BASE_URL + "/" + src}
                                                    className={`image ${documentUrl.length === 1 ? 'max-w-full h-auto' : ''}`}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </div>
    );
};
export default GuarantorDocumentView;